import './Archive.scss';
import HeroInformation from '../../Components/HeroInformation';
import Cards from './Cards/Cards';
import React, {useEffect} from 'react';
import {getMailings} from '../../../redux/actions/mailing/mailingActions';
import {useDispatch, useSelector} from 'react-redux';
import LoadPanel from '../../Components/LoadPanel';
import {useTranslation} from "react-i18next";
import {ButtonMUI} from "../../../shared";
import {setModal} from "../../../redux/actions/app/appActions";
import {POPUPS} from "../../../redux/actions/app/appActionTypes";
import {ReactComponent as MessageIcon} from '../../../assets/icons/mailWhite.svg';

const Archive = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {loading, mailing} = useSelector(({mailing}) => mailing);

    const handleMessageAdd = () => {
        dispatch(setModal(POPUPS.MAILING_POPUP));
    };

    useEffect(() => {
        const fetchFunc = async () => {
            dispatch(getMailings());
        };

        fetchFunc();
    }, []);
    return (
        <div className={'archive'}>
            <HeroInformation
                title={t('MailingPopup.archiveMailings')}
                description={
                    t('all.mailingText')
                }
                customHtml={<>
                    <ButtonMUI className={'archive-custom-button'} color={'default'} startIcon={<MessageIcon/>} onClick={handleMessageAdd}>
                        <span className={'button-text'}>{t('all.addMailing')}</span>
                    </ButtonMUI>
                </>}
            />
            {loading ? <LoadPanel noBg={true} circleSize={50} staticPos={true}/> : <Cards archiveArr={mailing}/>}
        </div>
    );
};

export default Archive;
